/* This file can be replaced during build by using the `fileReplacements` array.
 * `ng build` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */

export const commonEnv = {
  production: false,
  mode: 'development',
  title: 'Luminav Link - DEV',

  base_url: 'https://localhost:5026',
  version: '1.6.0',
  release_date: 'TDB', // during package update task: update the release date to 4 weeks from the last release date
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
